<mbs-modal
  [isCustomModal]="true"
  [limitedHeight]="true"
  [showFooter]="true"
  [title]="'wizards:entityWizards.company.administratorsStep.createModal.manualPermissions.title' | i18next">
  <ng-container modal-body>
    @if (ready()) {
      <mbs-permissions-tree
        [accountType]="accountType()"
        [globalMcpLevel]="mcpSettings.globalLevel()"
        [idPrefix]="'company-administrator-'"
        [permissions]="permissions()"
        (permissionsChange)="permissions.set($event)"></mbs-permissions-tree>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="applyClickHandler()">
      {{ 'wizards:entityWizards.company.administratorsStep.createModal.manualPermissions.apply' | i18next }}
    </mbs-button>

    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
